<template>
  <div class="" :class="containerClass">
    <div class="d-felx" :class="topTitleClass">
      <label v-if="topTitle != ''" class="d-inline my-2">{{ topTitle }}</label>
      <span v-if="required" class="text-danger mx-1">*</span>
    </div>
    <vue3-persian-datetime-picker
      ref="pickerControl"
      :inputClass="!validated ? 'isNotValid' : ''"
      :class="dateTimePickerClass"
      :key="componentKey"
      v-model="dateTimeValue"
      :color="color"
      :placeholder="placeholder"
      :clearable="clearable"
      :type="type"
      :compact-time="type == 'datetime'"
      :locale="locale"
      :min="min"
      :max="max"
      :disabled="disabled"
      :disable="disableDateTimes"
      :title="title"
      @input="this.$emit('input', dateTimeValue)"
      @change="onChange"
      @open="this.$emit('open', dateTimeValue)"
      @close="this.$emit('close', dateTimeValue)"
    ></vue3-persian-datetime-picker>
    <div v-if="!validated" class="errorSize" :class="errorClass">
      <span>{{ errorMessage }}</span>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import Vue3PersianDatetimePicker from 'vue3-persian-datetime-picker';
// import { persianDate } from '../../../../public/contents/scripts/dateConvertor.js';
export default {
  components: {
    Vue3PersianDatetimePicker,
  },
  props: {
    errorMessage: {
      type: String,
      required: false,
      default: '',
    },
    errorClass: {
      type: String,
      required: false,
      default: 'text-danger',
    },
    displayFormat: {
      type: String,
      default: '',
    },
    disableDateTimes: {
      type: Array,
      required: false,
      default: [],
    },

    dateTimePickerClass: {
      type: String,
      required: false,
      default: '',
    },
    time: {
      type: String,
      required: false,
      default: '',
    },
    year: {
      type: String,
      required: false,
      default: '',
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    gregorianDate: {
      type: String,
      required: false,
    },
    jalaliDate: {
      type: String,
      required: false,
    },
    initialValueType: {
      type: String,
      required: false,
      default: 'fa',
    },
    initialValue: {
      type: String,
      required: false,
    },
    type: {
      type: String,
      required: false,
      default: 'date',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    min: {
      type: String,
      required: false,
      default: '',
    },
    max: {
      type: String,
      required: false,
      default: '',
    },
    format: {
      type: String,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
      default: 'لطفا تاریخ را انتخاب کنید',
    },
    color: {
      type: String,
      required: false,
      default: '#7b7ce6',
    },
    locale: {
      type: String,
      required: false,
      default: 'fa,en',
    },
    clearable: {
      type: Boolean,
      required: false,
      default: true,
    },
    containerClass: {
      type: String,
      required: false,
      default: '',
    },
    topTitle: {
      type: String,
      required: false,
      default: 'انتخاب کنید :',
    },
    topTitleClass: {
      type: String,
      required: false,
      default: '',
    },
    dateTime: {
      type: String,
      required: false,
      default: '',
    },
  },
  watch: {
    dateTimeValue: function () {
      if (this.type === 'datetime') {
        if (!this.dateTimeValue) {
          this.$emit('update:dateTime', this.dateTimeValue);
          return;
        }
        let jalaliDateTime = `${new persianDate(
          this.dateTimeValue.split(' ')[0].split('/').map(Number)
        )
          .toCalendar('gregorian')
          .toLocale('en')
          .format('L')}T${this.dateTimeValue.split(' ')[1]}`.replaceAll(
          '/',
          '-'
        );
        this.$emit('update:dateTime', jalaliDateTime);
        return;
      }
      if (this.type === 'time') {
        this.$emit('update:time', this.dateTimeValue);
        this.$emit('timeChanged', this.dateTimeValue);
        return;
      }
      if (this.type == 'year') {
        this.$emit('update:year', this.dateTimeValue);
        this.$emit('yearChanged', this.dateTimeValue);
        return;
      }
      if (!this.dateTimeValue) {
        this.$emit('update:gregorianDate', '');
        this.$emit('update:jalaliDate', '');
        this.$emit('dateChanged', '', '');
        return;
      }
      this.gregorianDateValue = new persianDate(
        this.dateTimeValue.split('/').map(Number)
      )
        .toCalendar('gregorian')
        .toLocale('en')
        .format('L');
      this.title = new persianDate(new Date(this.gregorianDateValue)).format(
        'dddd DD MMMM YYYY'
      );
      this.$emit('update:gregorianDate', this.gregorianDateValue);
      this.jalaliDateValue = new persianDate(new Date(this.gregorianDateValue))
        .toLocale('en')
        .format('L');
      this.$emit('update:jalaliDate', this.jalaliDateValue);
      this.$emit('dateChanged', this.gregorianDateValue, this.jalaliDateValue);
    },
    initialValue: function () {
      this.componentKey += 1;
      if (this.initialValueType === 'en') {
        if (this.type === 'datetime') {
          if (!this.initialValue) {
            this.dateTimeValue = '';
            return;
          }

          this.dateTimeValue = `${new persianDate(
            new Date(`${this.initialValue}`)
          )
            .toLocale('en')
            .format('L')} ${
            this.initialValue.split('T')[1].split(':')[0] +
            ':' +
            this.initialValue.split('T')[1].split(':')[1]
          }`;
          return;
        }
        if (this.type === 'date' && !this.initialValue) {
          this.dateTimeValue = '';
          return;
        }

        this.dateTimeValue = new persianDate(new Date(this.initialValue))
          .toLocale('en')
          .format('L');
      } else {
        this.dateTimeValue = this.initialValue;
      }
    },
  },
  data() {
    return {
      validated: true,
      componentKey: 0,
      dateTimeValue: '',
      gregorianDateValue: '',
      jalaliDateValue: '',
      title: '',
    };
  },
  created() {
    // Initial value for component (Edit Time)
    if (this.initialValue) {
      if (this.initialValueType === 'en') {
        if (this.type === 'datetime') {
          this.dateTimeValue = `${new persianDate(
            new Date(`${this.initialValue}`)
          )
            .toLocale('en')
            .format('L')} ${
            this.initialValue.split('T')[1].split(':')[0] +
            ':' +
            this.initialValue.split('T')[1].split(':')[1]
          }`;
          return;
        }
        this.dateTimeValue = new persianDate(new Date(this.initialValue))
          .toLocale('en')
          .format('L');
      } else {
        this.dateTimeValue = this.initialValue;
      }
    }
  },
  methods: {
    onChange() {
      this.$emit('change', this.dateTimeValue);
      this.validated = true;
    },
    showErrorMessage() {
      this.validated = false;
    },
    hideErrorMessage() {
      this.validated = true;
    },
    setFocus() {
      this.$refs.pickerControl.focus();
    },
  },
};
</script>

<style>
.errorSize {
  font-size: 0.75em;
}
input[id^='vpd'] {
  height: 38px;
}
.vpd-input-group input.isNotValid {
  border: 1px;
}
@media (max-width: 575.98px) {
  .vpd-content {
    scale: 0.9 !important;
  }
  .vpd-header {
    padding: 5px 17px;
  }
  .vpd-wrapper[data-type='datetime'] .vpd-date {
    font-size: 16px !important;
    line-height: unset;
    height: unset;
  }
  .vpd-actions {
    padding: unset;
  }
  .vpd-container {
    top: 40%;
  }
}
</style>
<style scoped></style>
